import ttsPlayer, { onTtsState, getTtsState } from '@/modules/huyu-framework/backend/utils/ttsPlayer'

/**
 * 全局朗读状态唯一来源
 * 所有页面/组件（聊天页、AI 助手气泡、底部播放条）都读这里，不再各自镜像一份 ref，
 * 判定当前朗读对象统一用 messageId（消息稳定 ID），不再用文本内容比对。
 */
const useTtsStore = defineStore('tts', () => {
  const messageId = ref('')
  const text = ref('')
  const phase = ref('idle')          // idle | synthesizing | playing | paused
  const waiting = ref(false)         // 已播到已合成末尾，等待后续分段
  const currentTime = ref(0)
  const duration = ref(0)            // 已合成总时长（可拖动上限）
  const streamEnded = ref(false)
  const segIndex = ref(-1)
  const segText = ref('')
  const segTotal = ref(0)

  const active = computed(() => phase.value !== 'idle')
  // 播放条可见：进入合成/播放即显示
  const visible = computed(() => active.value)

  function applyState(s) {
    messageId.value = s.messageId
    text.value = s.text
    phase.value = s.phase
    waiting.value = s.waiting
    currentTime.value = s.currentTime
    duration.value = s.duration
    streamEnded.value = s.streamEnded
    segIndex.value = s.segIndex
    segText.value = s.segText
    segTotal.value = s.segTotal
  }

  // 播放内核为模块单例，store 初始化时一次性订阅，全局共享
  applyState(getTtsState())
  onTtsState(applyState)

  /** 当前是否正在朗读指定消息 */
  function isSpeaking(id) {
    return active.value && !!id && messageId.value === id
  }

  /** 朗读指定消息（同一条再点则停止） */
  async function toggle(id, content, options = {}) {
    return await ttsPlayer.toggle(id, content, options)
  }

  function stop() { ttsPlayer.stop() }
  function pause() { ttsPlayer.pause() }
  function resume() { ttsPlayer.resume() }
  function seek(time) { ttsPlayer.seek(time) }

  return {
    messageId, text, phase, waiting, currentTime, duration,
    streamEnded, segIndex, segText, segTotal,
    active, visible,
    isSpeaking, toggle, stop, pause, resume, seek
  }
})

export default useTtsStore
